export const LOGIN_USER_SUCCESS = 'login_user_success';
export const LOGIN_USER_FAILED = 'login_user_failed';
export const LOGIN_USER = 'login_user';
export const LOGOUT_USER = 'logout_user';

export const SCHEDULE_DAYS_UPDATE = 'schedule_days_update';
export const SCHEDULE_DAYS_UPDATE_SUCCESS = 'schedule_days_update_success';
export const SCHEDULE_DAYS_UPDATE_FAILED = 'schedule_days_update_failed';

export const SCHEDULE_DAYS_GET = 'schedule_days_get';
export const SCHEDULE_DAYS_GET_SUCCESS = 'schedule_days_get_success';
export const SCHEDULE_DAYS_GET_FAILED = 'schedule_days_get_failed';

//TODO(Celso): Pretty sure we can remove this from redux
export const POST_UPDATE_POSTS = 'post_update_posts';
export const POST_UPDATE_POSTS_FAIL = 'post_update_posts_fail';
export const POST_UPDATE_POSTS_SUCCESS = 'post_update_posts_success';



export const EDIT_UPDATE = 'edit_update';
export const EDIT_UPDATE_SUCCESS = 'edit_update_success';
export const EDIT_UPDATE_FAILED = 'edit_update_failed';

export const POST_TEXT_UPDATE = 'post_text_update';
export const POST_SEND = 'post_send';
export const POST_SEND_FAIL = 'post_send_fail';
export const POST_SEND_SUCCESS = 'post_send_sucess';

export const USER_POINTS_UPDATE = 'user_points_update';
export const USER_POINTS_UPDATE_FAIL = 'user_points_update_fail';
export const USER_POINTS_UPDATE_SUCCESS = 'user_points_update_success';

export const USER_UPDATE = 'user_update';
export const USER_UPDATE_SUCCESS = 'user_update_success';
export const USER_UPDATE_FAILED = 'user_update_failed';

export const USER_GET_AVATAR = 'user_get_avatar';
export const USER_GET_AVATAR_SUCCESS = 'user_get_avatar_success';
export const USER_GET_AVATAR_FAILED = 'user_get_avatar_failed';

export const REGISTER_DATA_UPDATE = 'register_data_update';
export const REGISTER_USER = 'register_user';
export const REGISTER_USER_FAIL = 'register_user_fail';
export const REGISTER_USER_SUCCESS = 'register_user_success';
export const REGISTER_UPDATE_USER_DATA = 'register_update_user_data';
